import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { mockInventory } from '../data/mock';

export default function InventoryView() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredInventory = mockInventory.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusColor = (status) => {
    switch(status) {
      case 'good': return 'border-maker-cyan text-maker-cyan';
      case 'low': return 'border-maker-tan text-maker-tan';
      case 'critical': return 'border-red-500 text-red-500';
      default: return 'border-gray-500 text-gray-500';
    }
  };

  return (
    <div className="space-y-6 h-full flex flex-col">
      <header className="flex flex-col md:flex-row md:justify-between md:items-end gap-4 mb-4">
        <div>
          <h1 className="text-3xl font-bold text-white">Materials Bins</h1>
          <p className="text-gray-400 font-mono text-sm">INVENTORY // STOCK_LEVELS</p>
        </div>
        
        <div className="relative w-full md:w-64">
          <SafeIcon name="Search" className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-4 h-4" />
          <input 
            type="text"
            placeholder="Search materials..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-graphite-800 border border-graphite-600 text-sm rounded-lg pl-10 pr-4 py-2 focus:outline-none focus:border-maker-cyan transition-colors"
          />
        </div>
      </header>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 pb-20">
        {filteredInventory.map((item) => (
          <div key={item.id} className={`glass-panel rounded-lg p-4 border-t-4 flex flex-col ${getStatusColor(item.status).split(' ')[0]}`}>
            <div className="flex justify-between items-start mb-2">
              <span className="font-mono text-xs text-gray-500 bg-graphite-900 px-2 py-1 rounded border border-graphite-700">
                BIN {item.bin}
              </span>
              <SafeIcon name="Archive" className="text-gray-600 w-4 h-4" />
            </div>
            
            <h3 className="font-semibold text-gray-200 text-sm mb-4 flex-1 line-clamp-2" title={item.name}>{item.name}</h3>
            
            <div className="mt-auto">
              <div className="flex justify-between items-baseline border-b border-graphite-700 pb-2 mb-2">
                <span className="text-2xl font-bold text-white">{item.qty}</span>
                <span className="text-xs text-gray-400 uppercase">{item.unit}</span>
              </div>
              
              <div className="flex justify-between items-center text-xs">
                <span className="text-gray-500">Unit Cost</span>
                <span className="font-mono text-maker-tan">${item.costPerUnit}</span>
              </div>
            </div>
          </div>
        ))}

        {/* Empty Add Slot */}
        <button className="glass-panel rounded-lg p-4 flex flex-col items-center justify-center min-h-[160px] border border-dashed border-graphite-600 hover:border-maker-cyan hover:bg-maker-cyan/5 transition-all text-gray-500 hover:text-maker-cyan group">
          <SafeIcon name="PlusCircle" className="w-8 h-8 mb-2 group-hover:glow-cyan rounded-full" />
          <span className="text-sm font-mono">LOG_MATERIAL</span>
        </button>
      </div>
    </div>
  );
}